import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

import { WorkbenchType } from './workbenches.types';

const URLS = {
  WORKBENCHES: '/products/workbenches/',
  WORKBENCH: '/products/workbenches/%s/',
};

export default {
  getWorkbenches: (params: SearchParamsType = {}) =>
    apiInstance.request({
      method: 'GET',
      url: URLS.WORKBENCHES,
      params: {
        ...params,
        ordering: '-id',
      },
    }),
  createWorkbench: (workbench: WorkbenchType | FormData) =>
    apiInstance.request({
      method: 'POST',
      url: URLS.WORKBENCHES,
      data: workbench,
    }),
  getWorkbench: ({ id }: { id: string }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.WORKBENCH, id),
    }),
  updateWorkbench: (briefing: WorkbenchType | FormData) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(
        URLS.WORKBENCH,
        briefing instanceof FormData ? briefing.get('id') : briefing.id
      ),
      data: briefing,
    }),

  removeWorkbench: ({ id }: { id: WorkbenchType['id'] }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.WORKBENCH, id),
    }),
};
